import {ColorValue, TextStyle} from 'react-native';
import {RoundedBtnDescriberProps} from 'src/components/elements/buttonDescriptor/DescriptorType';
import RoundedButton, {ButtonType} from 'src/components/elements/RoundedButton';
import Styles from 'src/components/Styles';
import Localized from 'src/constants/AppStrings';

export function roundedBtnColorDescriptor(props: RoundedBtnDescriberProps): {
  [index: string]: ColorValue;
} {
  let textColor = Styles.white;
  const disabledColor = Styles.lightGray;
  let fillColor = Styles.primaryColor;
  const buttonColor = props.disabled
    ? disabledColor
    : props.color || Styles.Colors.Canteen.darkGreen;
  if (props.buttonType === 'outline') {
    textColor = props.disabled
      ? disabledColor
      : props.color || Styles.Colors.Canteen.darkGreen;
    fillColor = Styles.transparent;
  } else {
    textColor = Styles.white;
    fillColor = props.disabled
      ? disabledColor
      : props.color || Styles.Colors.Canteen.darkGreen;
  }
  return {fillColor, textColor, buttonColor};
}

export function roundAppButtonSolidTextStyle(_disabled: boolean): TextStyle {
  return null;
}

export function roundAppButtonOutlineTextStyle(_disabled: boolean): TextStyle {
  return null;
}

export function checkRoundedBtnColor(_type?: ButtonType): string {
  return Styles.Colors.Canteen.darkGreen;
}

export function getSaveBtnManageAccount(handleSave) {
  return (
    <RoundedButton
      buttonType={ButtonType.action}
      text={Localized.Buttons.save}
      onPress={handleSave}
      accessible={true}
      addShadow={false}
      accessibilityLabel={Localized.Buttons.save}
      accessibilityRole="button"
      role="button"
      color={Styles.Colors.Canteen.darkGreen}
      aria-label={Localized.Buttons.save}
      containerStyle={{
        alignItems: 'center',
        left: Styles.Spacing.m3,
        right: Styles.Spacing.m3,
        bottom: Styles.Spacing.m3,
      }}
    />
  );
}

export function getTertiaryCTATextStyle(): TextStyle {
  return null;
}

export function buttonTextFontFamily(): string {
  return Styles.FontFamily.robotoRegular;
}
export function redeemRewardRoundedBtnColor(_type?: ButtonType): string {
  return Styles.Colors.Canteen.darkGreen;
}

export function redeemRewardIconColor(): string {
  return Styles.Colors.Canteen.darkGreen;
}

export default {
  roundedBtnColorDescriptor,
  roundAppButtonSolidTextStyle,
  roundAppButtonOutlineTextStyle,
  checkRoundedBtnColor,
  getSaveBtnManageAccount,
  getTertiaryCTATextStyle,
  buttonTextFontFamily,
  redeemRewardRoundedBtnColor,
  redeemRewardIconColor,
};
